var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"course-config"},[_c('iframe',{staticClass:"course-config-frame",attrs:{"src":_vm.src,"title":"日课配置","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }